import {ScaleConfig} from '@gongxigames/framework/slot/utils/ScaleUtils';

export const defaultReelsScaleConfig: Required<ScaleConfig> = {
    mobile: {
        landscape: {
            scale: 1,
            yOffset: 0,
            xOffset: 0
        },
        portrait: {
            scale: 0.7,
            yOffset: 753.6,
            xOffset: 0
        }
    },
    desktop: {
        scale: 1,
        yOffset: 0,
        xOffset: 0
    }
};
